<template>
  <div class="search-main-wrap">
    <div :style="{width:width+ 'px'}" class="inputDiv">
      <input type="hidden" v-model="queryJson">
      <el-input
        :placeholder="'点击进行查询'"
        @click.native="showSearch"
        size="mini"
        type="text"
        v-model="queryJsonText">
        <template slot="prepend" v-if="customSearchText && customSearchText.length > 0">{{ searchText }}</template>
      </el-input>
      <el-button
        @click="resetQuery(2)"
        plain
        size="mini"
        style="margin-left:7px;"
        type="primary">重置
      </el-button>
<!--      <el-button
        @click="showSearch"
        plain
        size="mini"
        style="margin-left:7px;"
        type="primary">高级查询
      </el-button>-->
    </div>
    <el-dialog
      :append-to-body='true'
      :before-close="handleClose"
      :visible="dialogVisible"
      title="组合查询"
      v-dialogDrag
      width="1200px">
      <slot/>
      <el-row type="flex" justify="space-around" align="middle">
        <el-col :span="10">
          <div v-if="searchList.length > 0" class="dynamic-form">
            <div
              :key="index"
              class="dynamic-search"
              style="min-width:480px;display:flex;justify-content:flex-start;"
              v-for="(search, index) in searchList">
              <!--增加并且或者功能-->
              <el-select
                size="mini"
                style="width:120px;"
                v-if="index !== 0"
                v-model="search.logicLink">
                <el-option
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in selectList"/>
              </el-select>
              <span
                v-else
                style="font-weight:700; font-size:14px; width:120px; text-align:center; margin-right:10px; line-height: 28px">
                第一组</span>
              <!-- 左边选择列的选择框 -->
              <el-select
                :class="index === 0 ? 'key-left' : 'key-right' "
                @change="updateType(index,search.key,1)"
                class="column-select"
                size="mini"
                style="width:150px;"
                v-model="search.key"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in columnList"/>
              </el-select>
              <!-- 中间选择条件的选择框 -->
              <el-select
                class="condition-select"
                size="mini"
                style="width:150px;"
                v-if="search.key && search.key.dataType === 'String'"
                v-model="search.condition"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in conditionListForString"/>
              </el-select>
              <el-select
                class="condition-select"
                size="mini"
                style="width:150px;"
                v-else
                v-model="search.condition"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in conditionList"/>
              </el-select>
              <!-- 右边是一个动态的根据当前选择列，来显示对应组件的框。 -->
              <template>
                <el-input-number
                  size="mini"
                  step-strictly
                  style="width:280px"
                  v-if="search.type === 'input' && search.dataType === 'Integer'"
                  v-model="search.value"/>
                <el-input-number
                  size="mini"
                  style="width:280px"
                  v-else-if="search.type === 'input' && isDouble(search)"
                  v-model="search.value"/>
                <el-input
                  :type="floatTypes.indexOf((search.dataType || '').toLowerCase()) > -1 ? 'number':'text'"
                  size="mini"
                  style="width:280px"
                  v-else-if="search.type === 'input'"
                  v-model="search.value"/>
                <el-select
                  size="mini"
                  style="width:280px"
                  v-if="search.type === 'select'"
                  v-model="search.value">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in search.props"/>
                </el-select>
                <el-date-picker
                  :picker-options="pickerOptions(search)"
                  :type="search.subtype || search.type"
                  :format="valueFormat(search)"
                  align="right"
                  placeholder="选择日期"
                  size="mini"
                  style="width:280px"
                  v-if="search.type === 'date' || search.type === 'datetime'"
                  v-model="search.value"/>
                <el-time-picker
                  placeholder="任意时间点"
                  size="mini"
                  style="width:270px"
                  v-if="search.type === 'time'"
                  v-model="search.value"
                  value-format="HH:mm:ss"/>
              </template>
            </div>
          </div>
        </el-col>
        <el-col :span="2">
          <el-select size="mini" style="width:100px;" v-model="groupConnector">
            <el-option
              :key="index"
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in selectList"/>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div v-if="searchList2.length > 0" class="dynamic-form">
            <div
              :key="index"
              class="dynamic-search"
              style="min-width:480px;display:flex;justify-content:flex-start;"
              v-for="(search, index) in searchList2">
              <!--增加并且或者功能-->
              <el-select
                size="mini"
                style="width:120px;"
                v-if="searchList2.length > 0 && index !== 0"
                v-model="search.logicLink">
                <el-option
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in selectList"/>
              </el-select>
              <span
                v-else
                style="font-weight:700; font-size:14px; width:120px; text-align:center; margin-right:10px; line-height: 28px">第二组</span>
              <!-- 左边选择列的选择框 -->
              <el-select
                :class="index === 0 ? 'key-left' : 'key-right' "
                @change="updateType(index,search.key,2)"
                class="column-select"
                size="mini"
                style="width:150px;"
                v-model="search.key"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in columnList"/>
              </el-select>
              <!-- 中间选择条件的选择框 -->
              <el-select
                class="condition-select"
                size="mini"
                style="width:150px;"
                v-if="search.key && search.key.dataType === 'String'"
                v-model="search.condition"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in conditionListForString"/>
              </el-select>
              <el-select
                class="condition-select"
                size="mini"
                style="width:150px;"
                v-else
                v-model="search.condition"
                value-key="value">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  v-for="item in conditionList"/>
              </el-select>
              <!-- 右边是一个动态的根据当前选择列，来显示对应组件的框。 -->
              <template>
                <el-input-number
                  size="mini"
                  step-strictly
                  style="width:280px"
                  v-if="search.type === 'input' && search.dataType === 'Integer'"
                  v-model="search.value"/>
                <el-input-number
                  size="mini"
                  style="width:280px"
                  v-else-if="search.type === 'input' && isDouble(search)"
                  v-model="search.value"/>
                <el-input
                  :type="floatTypes.indexOf((search.dataType || '').toLowerCase()) > -1 ? 'number':'text'"
                  size="mini"
                  style="width:280px"
                  v-else-if="search.type === 'input'"
                  v-model="search.value"/>
                <el-select
                  size="mini"
                  style="width:270px"
                  v-if="search.type === 'select'"
                  v-model="search.value">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in search.props"/>
                </el-select>
                <el-date-picker
                  :picker-options="pickerOptions(search)"
                  :type="search.subtype || search.type"
                  :format="valueFormat(search)"
                  align="right"
                  placeholder="选择日期"
                  size="mini"
                  style="width:270px;"
                  v-if="search.type === 'date' || search.type === 'datetime'"
                  v-model="search.value"/>
                <el-time-picker
                  placeholder="任意时间点"
                  size="mini"
                  style="width:270px;"
                  v-if="search.type === 'time'"
                  v-model="search.value"
                  value-format="HH:mm:ss"/>
              </template>
            </div>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetQuery(1)" size="small">清空</el-button>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="getQueryData" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {dateFormat2} from '@/utils/format/date'

export default {
  props: {
    isReset: {type: Boolean, default: false},
    // 传入的对象对应的列
    columnList: {type: Array, required: true},
    fuzzyFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 指定模糊查询相关字段名称
    fuzzyFieldNames: {
      type: Array,
      default: () => {
        return []
      }
    },
    width: {
      default: 800
    },
    // 是否存在查询条件
    isHasQuery: {type: Boolean, default: false},
    // 外部传进来的查询文本
    customSearchText: {type: String, default: ''}
  },
  computed: {
    searchText() {
      let text = this.customSearchText || ''
      if (this.queryJsonText && this.queryJsonText.length > 0) {
        if (this.customSearchText && this.customSearchText.length > 0) {
          text += '；'
        }
        text += this.queryJsonText
      }
      return text
    }
  },
  data() {
    return {
      dialogVisible: false,
      queryJson: '',
      queryJsonText: '',
      selectList: [
        {label: '并且', value: 'and'},
        {label: '或者', value: 'or'}
      ],
      // 条件列，固定不变。
      conditionList: [
        {label: '等于', value: 'EQ'},
        {label: '不等于', value: 'NE'},
        {label: '小于', value: 'LT'},
        {label: '大于', value: 'GT'},
        {label: '小于等于', value: 'LE'},
        {label: '大于等于', value: 'GE'},
        {label: '包含', value: 'LK'},
        {label: '右模糊', value: 'RLK'},
        {label: '左模糊', value: 'LLK'}
      ],
      // 条件列，固定不变。String类型无“大于”“小于”等操作符
      conditionListForString: [
        {label: '等于', value: 'EQ'},
        {label: '包含', value: 'LK'},
        {label: '右模糊', value: 'RLK'},
        {label: '左模糊', value: 'LLK'}
      ],
      searchList: [],
      searchList2: [],
      groupConnector: '',
      floatTypes: ['double', 'float', 'long', 'short', 'number']
    }
  },
  watch: {
    isReset(val) {
      this.initQueryList()
      this.queryJson = ''
      this.queryJsonText = ''
    }
  },
  mounted() {
    // 初始化查询组List
    this.initQueryList()
  },
  methods: {
    isDouble (search) {
      let dataType = search.dataType
      if (!dataType) {
        return false
      }
      dataType = dataType.toLowerCase()
      return dataType === 'bigdecimal' || dataType === 'double' || dataType === 'short'
    },
    valueFormat (search) {
      let type = search.subtype || search.type
      if (type === 'month') {
        return 'yyyy-MM'
      } else if (type === 'year') {
        return 'yyyy'
      } else if (type === 'date') {
        return 'yyyy-MM-dd'
      }
      return 'yyyy-MM-dd HH:mm'
    },
    pickerOptions (search) {
      let type = search.subtype || search.type
      if (type === 'month' || type === 'year') {
        return {}
      }
      return {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    },
    resetQuery(type) {
      this.$emit('resetSearch')
      this.initQueryList()
      if (type === 2) {
        this.$nextTick(() => {
          this.getQueryData()
        })
      }
    },
    initQueryList() {
      this.searchList = []
      this.searchList2 = []
      for (let i = 0; i < 5; i++) {
        this.searchList.push({
          key: '',
          condition: '',
          value: '',
          type: 'input',
          logicLink: this.selectList[0].value
        })
        this.searchList2.push({
          key: '',
          condition: '',
          value: '',
          type: 'input',
          logicLink: this.selectList[0].value
        })
        this.groupConnector = this.selectList[0].value
      }
      this.queryJsonText = ''
    },
    // 修改当前对应的key对应的type值。
    updateType(index, val, type) {
      // console.info(val)
      let b = ''
      if (type === 1) {
        b = this.searchList[index]
      } else {
        b = this.searchList2[index]
      }
      b.type = val.type
      b.subtype = val.subtype
      b.value = ''
      // b.condition = ''
      b.props = val.props
      b.dataType = val.dataType
      // console.info(b)
    },
    handleClose() {
      this.dialogVisible = false
    },
    showSearch() {
      this.dialogVisible = true
    },
    // removeSearch (item) {
    //   var index = this.searchList.indexOf(item)
    //   if (index !== -1) {
    //     this.searchList.splice(index, 1)
    //   }
    // },
    dealForQueryGroup(searchList) {
      let queryObj = {
        queryList: [],
        queryTextList: []
      }
      // 临时数组保存查询条件
      let searchList2 = []
      // 筛选掉空的查询列
      searchList.forEach((item, index) => {
        if (!item.key || (!item.value && item.value !== 0) || !item.condition) {
          return
        }
        searchList2.push(item)
      })
      searchList2.forEach((item, index) => {
        let queryText = ''
        if (item.logicLink && index !== 0) {
          if (item.logicLink === 'and') {
            queryText = '并且'
          } else {
            queryText = '或者'
          }
        }
        queryText += item.key.label + item.condition.label
        if (item.type === 'select') {
          item.props.forEach((o, index) => {
            if (o.value === item.value) {
              queryText += o.label
              return false
            }
          })
        } else if (item.dataType === 'Date') {
          if (item.subtype === 'month') {
            queryText += dateFormat2('yyyy-MM', item.value)
          } else if (item.subtype === 'year') {
            queryText += dateFormat2('yyyy', item.value)
          } else if (item.type === 'date') {
            queryText += dateFormat2('yyyy-MM-dd', item.value)
          } else {
            queryText += dateFormat2('yyyy-MM-dd hh:mm', item.value)
          }
        } else {
          queryText += item.value
        }
        queryObj.queryTextList.push(queryText)
        let queryField = {
          connector: '',
          name: '',
          type: '',
          operator: '',
          value: null
        }
        if (index === 0 && !this.isHasQuery) {
          queryField.connector = 'blank'
        } else {
          queryField.connector = item.logicLink
        }
        queryField.name = item.key.value
        queryField.type = item.key.dataType
        queryField.operator = item.condition.value
        if (item.dataType === 'Number' || item.dataType === 'number') {
          queryField.value = Number(item.value)
        } else if (item.dataType === 'Integer' || item.dataType === 'integer') {
          queryField.value = Number(item.value)
        } else if (item.dataType === 'Short' || item.dataType === 'short') {
          queryField.value = Number(item.value)
        } else if (item.dataType === 'Long' || item.dataType === 'long') {
          queryField.value = Number(item.value)
        } else if (item.dataType === 'Double' || item.dataType === 'double' || item.dataType === 'BigDecimal') {
          queryField.value = Number(item.value)
        } else if (item.dataType === 'Date' || item.dataType === 'date') {
          queryField.value = dateFormat2('yyyy-MM-dd hh:mm', item.value)
        } else {
          queryField.value = item.value.trim()
        }
        queryObj.queryList.push(queryField)
      })
      return queryObj
    },
    fuzzySearch() {
      let queryGroup = this.dealFuzzyGroup()

      this.$emit('search', queryGroup, [], this.groupConnector)
    },
    dealFuzzyGroup() {
      let queryGroup = []
      this.fuzzyFields.forEach((item, index) => {
        queryGroup.push({
          connector: index === 0 ? 'blank' : 'or',
          name: item,
          type: 'String',
          operator: 'LK',
          value: this.queryJsonText
        })
      })
      return queryGroup
    },
    getQueryData() {
      let queryObj1 = this.dealForQueryGroup(this.searchList)
      let queryGroup1 = queryObj1.queryList
      let queryObj2 = this.dealForQueryGroup(this.searchList2)
      let queryGroup2 = queryObj2.queryList
      // 第二组的第一个数据默认赋值为空
      if (queryGroup2.length > 0) {
        queryGroup2[0].connector = 'blank'
      }

      this.dialogVisible = false
      // this.$emit('search', queryGroup1, queryGroup2, this.groupConnector)
      this.queryJsonText = ''
      if (queryObj1.queryTextList.length > 0) {
        this.queryJsonText += '第一组：【' + queryObj1.queryTextList.join(',') + '】'
      }

      if (queryGroup2.length > 0) {
        if (this.groupConnector === 'and') {
          this.queryJsonText += ' 并且 '
        } else {
          this.queryJsonText += ' 或者 '
        }
      }

      if (queryObj2.queryTextList.length > 0) {
        this.queryJsonText += '第二组：【' + queryObj2.queryTextList.join(',') + '】'
      }
      this.$emit('search', queryGroup1, queryGroup2, this.groupConnector, this.queryJsonText)
    }
  }
}
</script>

<style scoped lang="scss">
.search-main-wrap {
  .inputDiv {
    height: 45px;
    display: flex;
    align-items: center;

    .el-input {
      /deep/
      input {
        cursor: pointer;
      }
    }
  }

  padding: 0 0;

  .condition-button {
    margin: 20px 0;
  }

  .dynamic-form {
    border: 1px dashed #ccc;
  }
}

.dynamic-search {
  padding: 4px;

  display: flex;
  justify-content: flex-start;

  .key-right {
    margin-left: 10px;
  }

  .left-select {
    margin-right: 10px;
  }

  .condition-select {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicSearch/index.vue